module.exports = __webpack_public_path__ + "static/img/certOfAuth.7a236510.png";